import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-2" }
const _hoisted_2 = {
  for: "name",
  class: "mb-2"
}
const _hoisted_3 = ["placeholder", "value"]

import { PropType } from "vue";
import i18n from '@/i18n/index'

export default /*#__PURE__*/_defineComponent({
  __name: 'inputFilter',
  props: {
    modelValue: {
        type: [String, Number, null] as PropType<string | number | null>,
        default: null,
    }
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, [
      _createVNode(_component_font_awesome_icon, {
        icon: "filter",
        size: "lg",
        class: "link-icon"
      }),
      _createTextVNode(" " + _toDisplayString(_unref(i18n).t('form.filter.title')), 1)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("input", _mergeProps({
        type: "text",
        placeholder: _unref(i18n).t('form.filter.title'),
        autocomplete: "off",
        class: "form-control"
      }, _ctx.$attrs, {
        value: __props.modelValue,
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value)))
      }), null, 16, _hoisted_3),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v?.$errors, (error) => {
        return (_openBlock(), _createElementBlock("span", {
          class: "text-danger",
          key: error.$uid
        }, _toDisplayString(error.$message), 1))
      }), 128))
    ])
  ]))
}
}

})